import {ObjectDTO} from '../../../object-dto';
import {PointFacturationDto} from '../points-facturation/point-facturation-dto';
import {AdresseDTO} from '../../../adresse-dto';
import {LigneFactureClientDto} from './ligne-facture-client-dto';
import {LigneFactureClientProduitComplementaireDto} from './ligne-facture-client-produit-complementaire-dto';
import {PrixDto} from '../../../prix-dto';
import {TypeFactureClientEnum} from "../../../../enums/facturation/client/type-facture-client-enum";
import {FactureClientPlcFraisFixeDto} from './facture-client-plc-frais-fixe-dto';


export class FactureClientDto extends ObjectDTO {

  pointFacturation: PointFacturationDto;
  statut: string;
  typeFactureClient: TypeFactureClientEnum;
  adressePointFacturation: AdresseDTO;
  adresseUdp: AdresseDTO;
  dateFacturation: Date;
  dateEcheance: Date;
  dateDebut: Date;
  dateFin: Date;
  numeroFacture: string;
  montantHT: PrixDto;
  montantTTC: PrixDto;
  quantite: number;
  montantFraisFixeAuCouvertHT: PrixDto;
  montantFraisFixeAuCouvertTTC: PrixDto;
  montantFraisFixeAuServiceHT: PrixDto;
  montantFraisFixeAuServiceTTC: PrixDto;
  ligneFactureClientList: LigneFactureClientDto[];
  ligneFactureClientProduitComplementaireList: LigneFactureClientProduitComplementaireDto[];
  plcFraisFixeAuServiceList: FactureClientPlcFraisFixeDto[];

  constructor() {
    super();
    this.id = 0;
  }

  public static getAllProperties = (): String => {
    return `
      id,
      site {
        id,
        libelle
      },
      statut,
      typeFactureClient,
      pointFacturation {
        id,
        libelle
      },
      adressePointFacturation {
        id,
        nom,
        ville,
        adresse1,
        adresse2,
        adresse3,
        telephone,
        fax,
        codePostal,
        ville,
        email
      },
      adresseUdp {
        id,
        nom,
        ville,
        adresse1,
        adresse2,
        adresse3,
        telephone,
        fax,
        codePostal,
        ville,
        email
      },
      dateFacturation,
      dateEcheance,
      dateDebut,
      dateFin,
      numeroFacture,
      montantHT {
        value,
        uniteMonetaire
      },
      montantTTC {
        value,
        uniteMonetaire
      },
      quantite,
      montantFraisFixeAuCouvertHT {
        value,
        uniteMonetaire
      },
      montantFraisFixeAuCouvertTTC {
        value,
        uniteMonetaire
      },
      montantFraisFixeAuServiceHT {
        value,
        uniteMonetaire
      },
      montantFraisFixeAuServiceTTC {
        value,
        uniteMonetaire
      },
      ligneFactureClientList {
        ${LigneFactureClientDto.getAllProperties()}
      },
      ligneFactureClientProduitComplementaireList {
        ${LigneFactureClientProduitComplementaireDto.getAllProperties()}
      },
      plcFraisFixeAuServiceList {
        codePlc,
        libellePlc,
        codeFraisFixe,
        libelleFraisFixe,
        montantHT {
          value,
          uniteMonetaire
        },
        tauxTva,
        montantTTC {
          value,
          uniteMonetaire
        }
      }
    `
  }
}
